/**
 * The primary tabs in the top bar.
 *
 * A flat row of the handful of destinations a role uses constantly — the same
 * set the phone's bottom bar carries, so the two navigations never disagree
 * about what "primary" means. Everything else lives behind ☰ Menu, which
 * lists every section the user can reach.
 *
 * This replaced a bar of grouped dropdowns. The grouping was a reasonable
 * answer to a real problem — twenty-five equally-weighted words is not a
 * layout — but it answered it in the wrong place: it made the five things you
 * click all day cost a menu, to spare the twenty you click monthly. The shell
 * this app replaces got the split right: a few flat tabs, and a drawer for
 * the long tail.
 */
import { NavLink } from "react-router-dom";
import type { AppRoute } from "./routes";

export function Nav({ items }: { items: AppRoute[] }) {
  return (
    <nav aria-label="Sections" className="flex items-center gap-0.5">
      {items.map((route) => (
        <NavLink
          key={route.path}
          to={route.path}
          className={({ isActive }) =>
            `whitespace-nowrap rounded-md px-2.5 py-2 text-[.88rem] no-underline ${
              isActive
                ? "bg-white/15 font-semibold text-white"
                : "text-white/70 hover:text-white"
            }`
          }
        >
          {route.nav!.label}
        </NavLink>
      ))}
    </nav>
  );
}
